import React from 'react';
import { SignOut } from '@phosphor-icons/react';

const SessionExpiredModal = ({ show, onClose, message }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full animate-fade-in">
        {/* Icon */}
        <div className="flex justify-center pt-8 pb-4">
          <div className="w-16 h-16 bg-wa-hover rounded-full flex items-center justify-center">
            <SignOut size={32} weight="bold" className="text-red-600" />
          </div>
        </div>

        {/* Content */}
        <div className="px-6 pb-6 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            Session Expired
          </h3>
          <p className="text-gray-600 leading-relaxed">
            {message || 'Your session has expired or you have logged in from another device. Please login again.'}
          </p>
        </div>

        {/* Action Button */}
        <div className="border-t border-gray-100 p-4">
          <button
            onClick={onClose}
            className="w-full bg-wa-panel border-l-4 border-[#e53935] hover:from-red-600 hover:to-red-700 text-wa-text-primary font-semibold py-3 px-6 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Login Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
